/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, type FC, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import { viewAssetService } from '../../services/viewAssetService'
import HierarchyView from '../ViewAsset/HierarchyView'
import LanguageStrings from '../../../../i18n/locales'
import './ViewAsset.css'
import { Button } from '../../../../components/Button'

interface ViwAsset {
  loading: boolean
  ViewAsset: any
  errorMsg: boolean
}

const ViewAssetStrings = LanguageStrings().AssetManagementCollectionStrings.TableComponent

const ViewAsset: FC<any> = (props) => {
  const [assetView, setassetView] = useState<ViwAsset>({
    loading: false,
    ViewAsset: {},
    errorMsg: false
  })

  useEffect(() => {
    viewAssetData()
  }, [props.assetId])

  const viewAssetData = (): any => {
    viewAssetService.viewAsset(props.assetId)
      .then((res: any) => {
        setassetView({ ...assetView, ViewAsset: res.data.data })
      })
      .catch(
        (res: any) => {
        }
      )
  }

  const { ViewAsset } = assetView

  return (
    <Grid container className="view_asset_popup" style={{ width: '45%' }} alignContent='flex-start'>
      <Grid item xs={12} className='asset_information'>
        <p>{ViewAssetStrings.HierarchyView}</p>
      </Grid>
      <HierarchyView site={ViewAsset?.hierarchyStructure?.site} id={props.assetId} />
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'end', bottom: '15px', right: '10px', position: 'absolute' }}>
            <Button type='hollow' className='view-close-btn' dataTestId="close-btn-click" onClick={() => { props.viewAssetPopup('') }}>
                {'Close'}
            </Button>
        </Grid>
    </Grid>
  )
}

export default ViewAsset
